import { connect } from 'react-redux'
import * as R from 'ramda'
import React, { Component } from 'react'
import _ from 'lodash'

import SingleSelectDropdownCreatableComponent from 'components/form/dropdownCreatable/index'
import { createNamedReducer } from 'helpers/ReducerUtil'
import { createNamedAction } from 'helpers/ActionUtil'
import dropdownReducer from './reducer'
import injectReducer from 'helpers/injectReducer'
import getSelectors from './selectors'
import {
  updateValue
} from './actions'
import {
  getPath,
  combinePath
} from 'containers/Form/util'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  const reducer = createNamedReducer(valuePath, dropdownReducer)

  return injectReducer(valuePath, reducer)
}

const withConnect = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)
  const updateValuesAction = createNamedAction(valuePath, updateValue)
  const {
    labelSelector,
    sourceSelector,
    valueSelector,
  } = getSelectors(combinedPath)

  const mapStateToProps = (state) => {
    const val = valueSelector(state)
    const srcs = sourceSelector(state)
    if (val !== null && srcs.filter(s => s.value === val).length === 0) srcs.push({label: val, value: val})
    return {
      title: labelSelector(state),
      values: val,
      source: srcs,
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      onChange: (value) => {
        dispatch(updateValuesAction(value))
      }
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

export const SingleSelectDropdownCreatable = (props) => {
    return (
      <SingleSelectDropdownCreatableComponent multiSelectable={false} {...props}/>
    )
}

export {
  withReducer,
  withConnect
}

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id),
)(SingleSelectDropdownCreatable))
